import React, { useState, useRef } from 'react'
import styles from "../../utilities/BrunoFamily/BrunoFamily.module.css"
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const BrunoFamily = () => {
  const sliderRef = useRef(null); // Reference for the slider

  const settings = {
    dots: false,
    infinite: true,
    speed: 1500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
  };

  // Array of slide data objects
  const slideData = [
    {
      id: 1,
      imgSrc: "images/bruno_family01.webp",
      title: "The Bruno Family",
      description: "Over 50 years ago, Dr. Antonio Bruno combined his passion for chemistry with the art of innovation to make lives better the world over. Bruno MD stands at the intersection of art and science. “I was fortunate to have a dream very early in life; to help improve human healthEven more fortunate, this dream became a career. And now, an even larger mission: to reach as many people as possible with better solutions for their well-being”. ",
    },
    {
      id: 2,
      imgSrc: "images/bruno_family02.webp",
      title: "Earlier Life",
      description: "Dr. Bruno was born in 1938 in a small town in southern Italy in the province of Avellino, an ancient and generous land characterized by rich, fertile soil and its people’s devotion to Avellino’s mountains, vast plains, and crystal-clear rivers.",
    },
    {
      id: 3,
      imgSrc: "images/bruno_family03.webp",
      title: "The Italian Soil",
      description: "The province is also a flourishing agricultural hub, and Dr. Bruno grew up appreciating this deep relationship between man and Madre Terra (Mother Earth). It instilled in him a passion for making high-quality products from the best ingredients.",
    },
    {
      id: 4,
      imgSrc: "images/bruno_family04.webp",
      title: "Earlier Career",
      description: "Dr. Bruno graduated with honors in chemistry from the University of Naples and pursued his passion for improving people’s lives working as a sales representative at the award-winning Milanese pharmaceutical company called Lepetit S.p.A .",
    },
    {
      id: 5,
      imgSrc: "images/bruno_family05.webp",
      title: "Bruno Farmaceutici since 1996",
      description: "Bruno Farmaceutici  in July 1996. Soon after, Dr. Bruno’s son, Vincenzo, and daughter Mariolina joined the effort, and the company became a family business in every sense of the .",
    },
    {
      id: 6,
      imgSrc: "images/bruno_family06.webp",
      title: "Bruno Farmaceutici today",
      description: "From futuristic eye care and life-saving cardiac treatments to Bruno MD prescription-grade supplements. We have an incredible lineup of products that will amaze you, and a few hundred more coming soon.“Or pride is giving people the tools to take ownership of their own health stories. These stories, we believe, are among the most incredible that nature and science can write together. We think you’ll agree” Dr. Bruno.",
    },

  ];

  const nextSlide = () => {
    sliderRef.current.slickNext();
  };

  const prevSlide = () => {
    sliderRef.current.slickPrev();
  };
  return (
    <div className="slider-container" id='BrunoFaimlly' style={{ position: 'relative' }} >
      <Slider ref={sliderRef} {...settings} >
        {slideData.map((slide) => (
          <div key={slide.id} className={styles.family_main}>
            <div className={styles.bruno_family}>
              <div className={styles.bruno_img1}>
                <img src={slide.imgSrc} alt="" />
              </div>
              <div className={styles.Bruno_content}>
                <div className={styles.Bruno_heading}>
                  <h2>{slide.title}</h2>
                </div>
                <div className={styles.p_decription}>
                  <p>{slide.description}</p>
                </div>
              </div>

            </div>

          </div>
        ))}
      </Slider>

      {/* Custom Button Wrapper Div */}
      <div className={styles.btnWrap}>
        <div className={styles.custom_btnDiv}>
          {/* Custom Previous Button */}
          <button
            onClick={prevSlide}
            className={`${styles.sliderButton} ${styles.prev_button}`}
          >
            <svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15.1641 26L45.4974 26" stroke="#7F7F7F" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M4.68932 26.2144L13.9538 31.773C14.487 32.093 15.1654 31.7089 15.1654 31.087L15.1654 20.913C15.1654 20.2911 14.487 19.907 13.9538 20.227L4.68932 25.7856C4.52749 25.8827 4.52749 26.1173 4.68932 26.2144Z" fill="#7F7F7F" />
            </svg>

          </button>

          {/* Custom Next Button */}
          <button
            onClick={nextSlide}
            className={`${styles.sliderButton} ${styles.next_button}`}
          >
            <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M37.832 26.832L7.50234 27.3025" stroke="#7F7F7F" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M48.3027 26.4545L38.9532 21.0402C38.4151 20.7285 37.7427 21.1231 37.7524 21.7449L37.9102 31.9177C37.9198 32.5395 38.6041 32.913 39.1323 32.5849L48.3094 26.8832C48.4697 26.7836 48.4661 26.5491 48.3027 26.4545Z" fill="#7F7F7F" />
            </svg>

          </button>
        </div>
      </div>


    </div>
  )
}

export default BrunoFamily
